var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_2486)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#53AE94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1707 43.3375V35.8992H73.1797V24.5664H26.8636V35.8992H43.8734V43.3312C30.0484 43.9664 19.6547 46.7043 19.6547 49.9844C19.6547 53.2644 30.0547 56.0024 43.8734 56.6414V80.4664H56.1734V56.6383C69.9734 56.0012 80.3472 53.2652 80.3472 49.9883C80.3472 46.7113 69.9734 43.9754 56.1734 43.3383L56.1707 43.3375ZM56.1734 54.6203V54.6145C55.8265 54.6363 54.0433 54.7434 50.0734 54.7434C46.8996 54.7434 44.6664 54.6535 43.8793 54.6125V54.6227C31.6652 54.0816 22.5484 51.9547 22.5484 49.4098C22.5484 46.8649 31.6664 44.7406 43.8793 44.1988V52.5039C44.6793 52.559 46.9672 52.6938 50.1254 52.6938C53.9183 52.6938 55.8254 52.5375 56.1754 52.5039V44.1992C68.3652 44.7422 77.4613 46.8711 77.4613 49.407C77.4613 51.943 68.3597 54.0731 56.1754 54.616",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_2486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.cf473b654503402ea88636d558e291b2.svg";
export { ForwardRef as ReactComponent };